import { render, staticRenderFns } from "./OssImg.vue?vue&type=template&id=05ede419&scoped=true&"
import script from "./OssImg.vue?vue&type=script&lang=js&"
export * from "./OssImg.vue?vue&type=script&lang=js&"
import style0 from "./OssImg.vue?vue&type=style&index=0&id=05ede419&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ede419",
  null
  
)

export default component.exports